import React from 'react'
import cx from 'classnames'

import Text from 'components/typography/Text/Text'

import s from './Title.scss'


const Title = ({ className, size = 'md', message, color, uppercase, center }) => (
  <Text
    className={cx(className, s.title, {
      [s.lg]: size === 'lg',
      [s.md]: size === 'md',
      [s.sm]: size === 'sm',
    })}
    tag="div"
    message={message}
    {...{ color, uppercase, center }}
  />
)


export default Title
